var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEngineering1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1666.959,
    height: 519.658,
    viewBox: "0 0 1666.959 519.658",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Engineering_1",
    transform: "translate(173.971 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_154460",
    "data-name": "\\uC0AC\\uAC01\\uD615 154460",
    width: 117.502,
    height: 62.952,
    transform: "translate(597.646 205.725)",
    fill: "#414042"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uC0AC\\uAC01\\uD615_154460_-_\\uC724\\uACFD\\uC120",
    "data-name": "\\uC0AC\\uAC01\\uD615 154460 - \\uC724\\uACFD\\uC120",
    d: "M0-1H117.5a1,1,0,0,1,1,1V62.952a1,1,0,0,1-1,1H0a1,1,0,0,1-1-1V0A1,1,0,0,1,0-1ZM116.5,1H1V61.952H116.5Z",
    transform: "translate(597.646 205.725)",
    fill: "#414042"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_154461",
    "data-name": "\\uC0AC\\uAC01\\uD615 154461",
    width: 530.51,
    height: 197.776,
    transform: "translate(702.755 279.163)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uC0AC\\uAC01\\uD615_154461_-_\\uC724\\uACFD\\uC120",
    "data-name": "\\uC0AC\\uAC01\\uD615 154461 - \\uC724\\uACFD\\uC120",
    d: "M0-1H530.51a1,1,0,0,1,1,1V197.776a1,1,0,0,1-1,1H0a1,1,0,0,1-1-1V0A1,1,0,0,1,0-1ZM529.51,1H1V196.776H529.51Z",
    transform: "translate(702.755 279.163)",
    fill: "#414042"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_185103",
    "data-name": "\\uADF8\\uB8F9 185103",
    transform: "translate(1169.893 163.637)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_154462",
    "data-name": "\\uC0AC\\uAC01\\uD615 154462",
    width: 8.043,
    height: 22.51,
    transform: "translate(3.113 44.208) rotate(7.754)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uC0AC\\uAC01\\uD615_154462_-_\\uC724\\uACFD\\uC120",
    "data-name": "\\uC0AC\\uAC01\\uD615 154462 - \\uC724\\uACFD\\uC120",
    d: "M0-1H8.043a1,1,0,0,1,1,1V22.51a1,1,0,0,1-1,1H0a1,1,0,0,1-1-1V0A1,1,0,0,1,0-1ZM7.043,1H1V21.51H7.043Z",
    transform: "translate(3.113 44.208) rotate(7.754)",
    fill: "#414042"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_132674",
    "data-name": "\\uD328\\uC2A4 132674",
    d: "M665.755,149.418l2.921,8.355,5.048-7.27Z",
    transform: "translate(-665.679 -82.905)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_132674_-_\\uC724\\uACFD\\uC120",
    "data-name": "\\uD328\\uC2A4 132674 - \\uC724\\uACFD\\uC120",
    d: "M665.755,148.418a1,1,0,0,1,.135.009l7.969,1.085a1,1,0,0,1,.686,1.561l-5.048,7.27a1,1,0,0,1-1.765-.24l-2.921-8.355a1,1,0,0,1,.944-1.33Zm6.217,2.856-4.734-.645,1.735,4.963Z",
    transform: "translate(-665.679 -82.905)",
    fill: "#414042"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_154463",
    "data-name": "\\uC0AC\\uAC01\\uD615 154463",
    width: 8.043,
    height: 35.629,
    transform: "translate(7.921 8.905) rotate(7.754)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uC0AC\\uAC01\\uD615_154463_-_\\uC724\\uACFD\\uC120",
    "data-name": "\\uC0AC\\uAC01\\uD615 154463 - \\uC724\\uACFD\\uC120",
    d: "M0-1H8.043a1,1,0,0,1,1,1V35.629a1,1,0,0,1-1,1H0a1,1,0,0,1-1-1V0A1,1,0,0,1,0-1ZM7.043,1H1V34.629H7.043Z",
    transform: "translate(7.921 8.905) rotate(7.754)",
    fill: "#414042"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_154464",
    "data-name": "\\uC0AC\\uAC01\\uD615 154464",
    width: 8.043,
    height: 3.054,
    transform: "translate(7.921 8.905) rotate(7.754)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uC0AC\\uAC01\\uD615_154464_-_\\uC724\\uACFD\\uC120",
    "data-name": "\\uC0AC\\uAC01\\uD615 154464 - \\uC724\\uACFD\\uC120",
    d: "M0-1H8.043a1,1,0,0,1,1,1V3.054a1,1,0,0,1-1,1H0a1,1,0,0,1-1-1V0A1,1,0,0,1,0-1ZM7.043,1H1V2.054H7.043Z",
    transform: "translate(7.921 8.905) rotate(7.754)",
    fill: "#414042"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_132675",
    "data-name": "\\uD328\\uC2A4 132675",
    d: "M665.725,157.172a1,1,0,0,1-.992-1.135l4.219-30.98a1,1,0,0,1,1.126-.856l2.738.373a1,1,0,0,1-.27,1.982l-1.747-.238-4.084,29.989A1,1,0,0,1,665.725,157.172Z",
    transform: "translate(-665.724 -116.791)",
    fill: "#414042"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_154465",
    "data-name": "\\uC0AC\\uAC01\\uD615 154465",
    width: 4.417,
    height: 9.234,
    transform: "translate(10.963 0) rotate(7.754)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uC0AC\\uAC01\\uD615_154465_-_\\uC724\\uACFD\\uC120",
    "data-name": "\\uC0AC\\uAC01\\uD615 154465 - \\uC724\\uACFD\\uC120",
    d: "M0-1H4.417a1,1,0,0,1,1,1V9.234a1,1,0,0,1-1,1H0a1,1,0,0,1-1-1V0A1,1,0,0,1,0-1ZM3.417,1H1V8.234H3.417Z",
    transform: "translate(10.963 0) rotate(7.754)",
    fill: "#414042"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_185104",
    "data-name": "\\uADF8\\uB8F9 185104",
    transform: "translate(1141.74 171.464)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_154466",
    "data-name": "\\uC0AC\\uAC01\\uD615 154466",
    width: 8.043,
    height: 46.348,
    transform: "translate(1.766 13.493) rotate(-8.133)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uC0AC\\uAC01\\uD615_154466_-_\\uC724\\uACFD\\uC120",
    "data-name": "\\uC0AC\\uAC01\\uD615 154466 - \\uC724\\uACFD\\uC120",
    d: "M0-1H8.043a1,1,0,0,1,1,1V46.348a1,1,0,0,1-1,1H0a1,1,0,0,1-1-1V0A1,1,0,0,1,0-1ZM7.043,1H1V45.348H7.043Z",
    transform: "translate(1.766 13.493) rotate(-8.133)",
    fill: "#414042"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_132676",
    "data-name": "\\uD328\\uC2A4 132676",
    d: "M657.457,150.368l5.1,7.236,2.866-8.374Z",
    transform: "translate(-649.134 -90.994)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_132676_-_\\uC724\\uACFD\\uC120",
    "data-name": "\\uD328\\uC2A4 132676 - \\uC724\\uACFD\\uC120",
    d: "M665.419,148.23a1,1,0,0,1,.946,1.324l-2.866,8.374a1,1,0,0,1-1.764.252l-5.1-7.236a1,1,0,0,1,.676-1.566l7.962-1.138A1,1,0,0,1,665.419,148.23Zm-3.177,7.2,1.7-4.975-4.73.676Z",
    transform: "translate(-649.134 -90.994)",
    fill: "#414042"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_154467",
    "data-name": "\\uC0AC\\uAC01\\uD615 154467",
    width: 8.043,
    height: 3.863,
    transform: "translate(1.219 9.669) rotate(-8.133)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uC0AC\\uAC01\\uD615_154467_-_\\uC724\\uACFD\\uC120",
    "data-name": "\\uC0AC\\uAC01\\uD615 154467 - \\uC724\\uACFD\\uC120",
    d: "M0-1H8.043a1,1,0,0,1,1,1V3.863a1,1,0,0,1-1,1H0a1,1,0,0,1-1-1V0A1,1,0,0,1,0-1ZM7.043,1H1V2.863H7.043Z",
    transform: "translate(1.219 9.669) rotate(-8.133)",
    fill: "#414042"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uC0AC\\uAC01\\uD615_154468",
    "data-name": "\\uC0AC\\uAC01\\uD615 154468",
    d: "M1.676,0h4.69A1.676,1.676,0,0,1,8.043,1.676V8.618a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V1.676A1.676,1.676,0,0,1,1.676,0Z",
    transform: "translate(0 1.138) rotate(-8.133)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uC0AC\\uAC01\\uD615_154468_-_\\uC724\\uACFD\\uC120",
    "data-name": "\\uC0AC\\uAC01\\uD615 154468 - \\uC724\\uACFD\\uC120",
    d: "M1.676-1h4.69A2.68,2.68,0,0,1,9.043,1.676V8.618a1,1,0,0,1-1,1H0a1,1,0,0,1-1-1V1.676A2.68,2.68,0,0,1,1.676-1ZM7.043,7.618V1.676A.677.677,0,0,0,6.366,1H1.676A.677.677,0,0,0,1,1.676V7.618Z",
    transform: "translate(0 1.138) rotate(-8.133)",
    fill: "#414042"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_154469",
    "data-name": "\\uC0AC\\uAC01\\uD615 154469",
    width: 125.646,
    height: 81.437,
    transform: "translate(555.878 279.163)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uC0AC\\uAC01\\uD615_154469_-_\\uC724\\uACFD\\uC120",
    "data-name": "\\uC0AC\\uAC01\\uD615 154469 - \\uC724\\uACFD\\uC120",
    d: "M0-1H125.646a1,1,0,0,1,1,1V81.437a1,1,0,0,1-1,1H0a1,1,0,0,1-1-1V0A1,1,0,0,1,0-1ZM124.646,1H1V80.437H124.646Z",
    transform: "translate(555.878 279.163)",
    fill: "#414042"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_154470",
    "data-name": "\\uC0AC\\uAC01\\uD615 154470",
    width: 7.271,
    height: 10.66,
    rx: 1.516,
    transform: "translate(1069.367 247.249)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uC0AC\\uAC01\\uD615_154470_-_\\uC724\\uACFD\\uC120",
    "data-name": "\\uC0AC\\uAC01\\uD615 154470 - \\uC724\\uACFD\\uC120",
    d: "M1.516-1h4.24A2.518,2.518,0,0,1,8.271,1.516V9.144A2.518,2.518,0,0,1,5.756,11.66H1.516A2.518,2.518,0,0,1-1,9.144V1.516A2.518,2.518,0,0,1,1.516-1ZM5.756,9.66a.516.516,0,0,0,.516-.516V1.516A.516.516,0,0,0,5.756,1H1.516A.516.516,0,0,0,1,1.516V9.144a.516.516,0,0,0,.516.516Z",
    transform: "translate(1069.367 247.249)",
    fill: "#414042"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uC0AC\\uAC01\\uD615_154471",
    "data-name": "\\uC0AC\\uAC01\\uD615 154471",
    d: "M0-1H239.657a1,1,0,0,1,1,1V6.1a5.364,5.364,0,0,1-5.358,5.358H4.358A5.364,5.364,0,0,1-1,6.1V0A1,1,0,0,1,0-1ZM238.657,1H1V6.1A3.362,3.362,0,0,0,4.358,9.454H235.3A3.362,3.362,0,0,0,238.657,6.1Z",
    transform: "translate(781.251 258.223)",
    fill: "#414042"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_132677",
    "data-name": "\\uD328\\uC2A4 132677",
    d: "M796.773,90.338a24.154,24.154,0,0,0-24.155-24.155H513.8A24.156,24.156,0,0,0,489.64,90.338v129.41H796.773Z",
    transform: "translate(257.872 -35.693)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_132677_-_\\uC724\\uACFD\\uC120",
    "data-name": "\\uD328\\uC2A4 132677 - \\uC724\\uACFD\\uC120",
    d: "M513.8,65.183h258.82a25.134,25.134,0,0,1,25.155,25.155v129.41a1,1,0,0,1-1,1H489.64a1,1,0,0,1-1-1V90.338A25.137,25.137,0,0,1,513.8,65.183ZM795.773,218.749V90.338a23.134,23.134,0,0,0-23.155-23.155H513.8A23.135,23.135,0,0,0,490.64,90.338v128.41Z",
    transform: "translate(257.872 -35.693)",
    fill: "#414042"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_185105",
    "data-name": "\\uADF8\\uB8F9 185105",
    transform: "translate(756.239 39.214)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_132678",
    "data-name": "\\uD328\\uC2A4 132678",
    d: "M493.278,214.661V85.251A15.448,15.448,0,0,1,508.709,69.82h258.82a15.449,15.449,0,0,1,15.431,15.431v129.41Z",
    transform: "translate(-493.278 -69.82)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_132678_-_\\uC724\\uACFD\\uC120",
    "data-name": "\\uD328\\uC2A4 132678 - \\uC724\\uACFD\\uC120",
    d: "M782.961,215.661H493.278a1,1,0,0,1-1-1V85.251A16.45,16.45,0,0,1,508.709,68.82h258.82a16.45,16.45,0,0,1,16.431,16.431v129.41A1,1,0,0,1,782.961,215.661Zm-288.683-2H781.961V85.251A14.448,14.448,0,0,0,767.529,70.82H508.709a14.447,14.447,0,0,0-14.431,14.431Z",
    transform: "translate(-493.278 -69.82)",
    fill: "#414042"
  })), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_132679",
    "data-name": "\\uD328\\uC2A4 132679",
    d: "M513.8,164.231h258.82a24.154,24.154,0,0,0,24.155-24.155V130.2H489.64v9.873A24.156,24.156,0,0,0,513.8,164.231Z",
    transform: "translate(257.872 53.854)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_132679_-_\\uC724\\uACFD\\uC120",
    "data-name": "\\uD328\\uC2A4 132679 - \\uC724\\uACFD\\uC120",
    d: "M772.618,165.231H513.8a25.135,25.135,0,0,1-25.158-25.155V130.2a1,1,0,0,1,1-1H796.773a1,1,0,0,1,1,1v9.873a25.134,25.134,0,0,1-25.155,25.155ZM490.64,131.2v8.873A23.137,23.137,0,0,0,513.8,163.231h258.82a23.134,23.134,0,0,0,23.155-23.155V131.2Z",
    transform: "translate(257.872 53.854)",
    fill: "#414042"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_132680",
    "data-name": "\\uD328\\uC2A4 132680",
    d: "M674.683,165.479H393.867v10.487h276.98",
    transform: "translate(123.909 103.197)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_132680_-_\\uC724\\uACFD\\uC120",
    "data-name": "\\uD328\\uC2A4 132680 - \\uC724\\uACFD\\uC120",
    d: "M670.847,176.966H393.867a1,1,0,0,1-1-1V165.479a1,1,0,0,1,1-1H674.683a1,1,0,0,1,0,2H394.867v8.487h275.98a1,1,0,0,1,0,2Z",
    transform: "translate(123.909 103.197)",
    fill: "#414042"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_132681",
    "data-name": "\\uD328\\uC2A4 132681",
    d: "M596.374,165.479H877.217v10.487H600.237",
    transform: "translate(407.166 103.197)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_132681_-_\\uC724\\uACFD\\uC120",
    "data-name": "\\uD328\\uC2A4 132681 - \\uC724\\uACFD\\uC120",
    d: "M877.217,176.966H600.237a1,1,0,0,1,0-2h275.98v-8.487H596.374a1,1,0,0,1,0-2H877.217a1,1,0,0,1,1,1v10.487A1,1,0,0,1,877.217,176.966Z",
    transform: "translate(407.166 103.197)",
    fill: "#414042"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_132682",
    "data-name": "\\uD328\\uC2A4 132682",
    d: "M728.127,252.134C719.081,214.193,665.5,118.221,618.7,118.221S518.316,214.193,509.27,252.134c-8.846,37.111,10.617,65.006,49.839,65.006H678.288C717.508,317.14,736.973,289.245,728.127,252.134Z",
    transform: "translate(282.382 37.096)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_132682_-_\\uC724\\uACFD\\uC120",
    "data-name": "\\uD328\\uC2A4 132682 - \\uC724\\uACFD\\uC120",
    d: "M678.288,318.14H559.109a64.222,64.222,0,0,1-25.4-4.771,44.416,44.416,0,0,1-17.633-13.293,45.982,45.982,0,0,1-9.152-21.353A68.1,68.1,0,0,1,508.3,251.9c2.32-9.729,7.436-22.918,14.407-37.139a326.5,326.5,0,0,1,26.3-44.392,240.313,240.313,0,0,1,16.135-20.447,152.748,152.748,0,0,1,17.351-16.889c12.852-10.493,25.033-15.814,36.2-15.814s23.352,5.321,36.2,15.814a152.748,152.748,0,0,1,17.351,16.889,240.313,240.313,0,0,1,16.135,20.447,326.486,326.486,0,0,1,26.3,44.392c6.971,14.22,12.088,27.41,14.407,37.139a68.093,68.093,0,0,1,1.377,26.821,45.983,45.983,0,0,1-9.152,21.353,44.418,44.418,0,0,1-17.634,13.293A64.218,64.218,0,0,1,678.288,318.14ZM618.7,119.221c-10.7,0-22.453,5.169-34.939,15.363a150.748,150.748,0,0,0-17.12,16.668,238.308,238.308,0,0,0-16,20.276,324.458,324.458,0,0,0-26.14,44.116c-6.908,14.091-11.972,27.133-14.258,36.722a66.115,66.115,0,0,0-1.349,26.033,44.007,44.007,0,0,0,8.748,20.438,42.439,42.439,0,0,0,16.852,12.694,62.244,62.244,0,0,0,24.616,4.61H678.288a62.24,62.24,0,0,0,24.615-4.61,42.44,42.44,0,0,0,16.852-12.694A44.008,44.008,0,0,0,728.5,278.4a66.111,66.111,0,0,0-1.349-26.033c-2.286-9.589-7.35-22.631-14.258-36.722a324.458,324.458,0,0,0-26.14-44.116,238.308,238.308,0,0,0-16-20.276,150.748,150.748,0,0,0-17.12-16.668C641.152,124.39,629.4,119.221,618.7,119.221Z",
    transform: "translate(282.382 37.096)",
    fill: "#414042"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_132683",
    "data-name": "\\uD328\\uC2A4 132683",
    d: "M675.249,234.149H556.069c-17.174,0-30.645-5.563-38.956-16.087-8.531-10.8-10.945-26.339-6.8-43.744a1,1,0,1,1,1.945.464c-4,16.8-1.723,31.728,6.421,42.04,7.918,10.027,20.846,15.327,37.386,15.327h119.18c16.541,0,29.468-5.3,37.384-15.327a1,1,0,0,1,1.57,1.239C705.894,228.586,692.424,234.149,675.249,234.149Z",
    transform: "translate(285.421 115.886)",
    fill: "#414042"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_132684",
    "data-name": "\\uD328\\uC2A4 132684",
    d: "M605.007,210.171h-.044a1,1,0,0,1-.956-1.043,65.506,65.506,0,0,0-1.873-17.984c-1.809-7.591-5.308-17.231-10.119-27.878a1,1,0,0,1,1.823-.824c4.863,10.762,8.4,20.526,10.242,28.238a67.5,67.5,0,0,1,1.926,18.535A1,1,0,0,1,605.007,210.171Z",
    transform: "translate(402.344 99.524)",
    fill: "#414042"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_185106",
    "data-name": "\\uADF8\\uB8F9 185106",
    transform: "translate(771.473 354.236)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_132685",
    "data-name": "\\uD328\\uC2A4 132685",
    d: "M587.464,201.147,499.629,364.569H510.9l87.836-163.421Z",
    transform: "translate(-499.629 -201.147)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_132685_-_\\uC724\\uACFD\\uC120",
    "data-name": "\\uD328\\uC2A4 132685 - \\uC724\\uACFD\\uC120",
    d: "M587.464,200.147h11.272a1,1,0,0,1,.881,1.473L511.782,365.042a1,1,0,0,1-.881.527H499.629a1,1,0,0,1-.881-1.473l87.836-163.421A1,1,0,0,1,587.464,200.147Zm9.6,2h-9L501.3,363.569h9Z",
    transform: "translate(-499.629 -201.147)",
    fill: "#414042"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_132686",
    "data-name": "\\uD328\\uC2A4 132686",
    d: "M574.077,201.147l87.836,163.421H650.64L562.8,201.147Z",
    transform: "translate(-411.262 -201.147)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_132686_-_\\uC724\\uACFD\\uC120",
    "data-name": "\\uD328\\uC2A4 132686 - \\uC724\\uACFD\\uC120",
    d: "M562.8,200.147h11.272a1,1,0,0,1,.881.527L662.793,364.1a1,1,0,0,1-.881,1.473H650.64a1,1,0,0,1-.881-.527L561.924,201.621a1,1,0,0,1,.881-1.473Zm10.675,2h-9l86.761,161.421h9Z",
    transform: "translate(-411.262 -201.147)",
    fill: "#414042"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_154472",
    "data-name": "\\uC0AC\\uAC01\\uD615 154472",
    width: 11.052,
    height: 163.421,
    transform: "translate(119.799)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uC0AC\\uAC01\\uD615_154472_-_\\uC724\\uACFD\\uC120",
    "data-name": "\\uC0AC\\uAC01\\uD615 154472 - \\uC724\\uACFD\\uC120",
    d: "M0-1H11.052a1,1,0,0,1,1,1V163.421a1,1,0,0,1-1,1H0a1,1,0,0,1-1-1V0A1,1,0,0,1,0-1ZM10.052,1H1V162.421h9.052Z",
    transform: "translate(119.799)",
    fill: "#414042"
  })), /*#__PURE__*/React.createElement("path", {
    id: "\\uC120_1642",
    "data-name": "\\uC120 1642",
    d: "M177.076,1H0A1,1,0,0,1-1,0,1,1,0,0,1,0-1H177.076a1,1,0,0,1,1,1A1,1,0,0,1,177.076,1Z",
    transform: "translate(808.539 448.694)",
    fill: "#414042"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD0C0\\uC6D0_21792",
    "data-name": "\\uD0C0\\uC6D0 21792",
    d: "M4.363-1A5.363,5.363,0,1,1-1,4.363,5.369,5.369,0,0,1,4.363-1Zm0,8.725A3.363,3.363,0,1,0,1,4.363,3.367,3.367,0,0,0,4.363,7.725Z",
    transform: "translate(1024.722 198.89)",
    fill: "#414042"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uC0AC\\uAC01\\uD615_154473",
    "data-name": "\\uC0AC\\uAC01\\uD615 154473",
    d: "M7.086,0H28.575a7.086,7.086,0,0,1,7.086,7.086V17a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V7.086A7.086,7.086,0,0,1,7.086,0Z",
    transform: "translate(1054.646 251.679)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uC0AC\\uAC01\\uD615_154473_-_\\uC724\\uACFD\\uC120",
    "data-name": "\\uC0AC\\uAC01\\uD615 154473 - \\uC724\\uACFD\\uC120",
    d: "M7.086-1H28.575a8.1,8.1,0,0,1,8.086,8.086V17a1,1,0,0,1-1,1H0a1,1,0,0,1-1-1V7.086A8.1,8.1,0,0,1,7.086-1ZM34.661,16V7.086A6.093,6.093,0,0,0,28.575,1H7.086A6.093,6.093,0,0,0,1,7.086V16Z",
    transform: "translate(1054.646 251.679)",
    fill: "#414042"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_132687",
    "data-name": "\\uD328\\uC2A4 132687",
    d: "M627.09,165.208h1.173a15.809,15.809,0,0,0,9.629-3.272h0",
    transform: "translate(450.131 98.242)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_132687_-_\\uC724\\uACFD\\uC120",
    "data-name": "\\uD328\\uC2A4 132687 - \\uC724\\uACFD\\uC120",
    d: "M628.263,166.208H627.09a1,1,0,0,1,0-2h1.173a14.887,14.887,0,0,0,9.02-3.065,1,1,0,0,1,1.218,1.586A16.9,16.9,0,0,1,628.263,166.208Z",
    transform: "translate(450.131 98.242)",
    fill: "#414042"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_132688",
    "data-name": "\\uD328\\uC2A4 132688",
    d: "M830.742,224.049H719.057l15.415,108.486h80.855Z",
    transform: "translate(578.77 185.122)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_132688_-_\\uC724\\uACFD\\uC120",
    "data-name": "\\uD328\\uC2A4 132688 - \\uC724\\uACFD\\uC120",
    d: "M719.057,223.049H830.742a1,1,0,0,1,.99,1.141L816.317,332.676a1,1,0,0,1-.99.859H734.472a1,1,0,0,1-.99-.859L718.067,224.19a1,1,0,0,1,.99-1.141Zm110.533,2H720.209L735.34,331.535h79.119Z",
    transform: "translate(578.77 185.122)",
    fill: "#414042"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_154474",
    "data-name": "\\uC0AC\\uAC01\\uD615 154474",
    width: 88.511,
    height: 44.209,
    transform: "translate(574.445 297.777)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uC0AC\\uAC01\\uD615_154474_-_\\uC724\\uACFD\\uC120",
    "data-name": "\\uC0AC\\uAC01\\uD615 154474 - \\uC724\\uACFD\\uC120",
    d: "M0-1H88.511a1,1,0,0,1,1,1V44.209a1,1,0,0,1-1,1H0a1,1,0,0,1-1-1V0A1,1,0,0,1,0-1ZM87.511,1H1V43.209H87.511Z",
    transform: "translate(574.445 297.777)",
    fill: "#414042"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uC0AC\\uAC01\\uD615_154475",
    "data-name": "\\uC0AC\\uAC01\\uD615 154475",
    d: "M2.911,0h48.8a2.911,2.911,0,0,1,2.911,2.911V6.982a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V2.911A2.911,2.911,0,0,1,2.911,0Z",
    transform: "translate(591.388 316.391)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uC0AC\\uAC01\\uD615_154475_-_\\uC724\\uACFD\\uC120",
    "data-name": "\\uC0AC\\uAC01\\uD615 154475 - \\uC724\\uACFD\\uC120",
    d: "M2.911-1h48.8a3.915,3.915,0,0,1,3.911,3.911V6.982a1,1,0,0,1-1,1H0a1,1,0,0,1-1-1V2.911A3.915,3.915,0,0,1,2.911-1ZM53.625,5.982V2.911A1.913,1.913,0,0,0,51.715,1H2.911A1.913,1.913,0,0,0,1,2.911V5.982Z",
    transform: "translate(591.388 316.391)",
    fill: "#414042"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_154476",
    "data-name": "\\uC0AC\\uAC01\\uD615 154476",
    width: 125.646,
    height: 81.437,
    transform: "translate(555.878 360.601)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uC0AC\\uAC01\\uD615_154476_-_\\uC724\\uACFD\\uC120",
    "data-name": "\\uC0AC\\uAC01\\uD615 154476 - \\uC724\\uACFD\\uC120",
    d: "M0-1H125.646a1,1,0,0,1,1,1V81.437a1,1,0,0,1-1,1H0a1,1,0,0,1-1-1V0A1,1,0,0,1,0-1ZM124.646,1H1V80.437H124.646Z",
    transform: "translate(555.878 360.601)",
    fill: "#414042"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_154477",
    "data-name": "\\uC0AC\\uAC01\\uD615 154477",
    width: 88.511,
    height: 44.209,
    transform: "translate(574.445 379.215)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uC0AC\\uAC01\\uD615_154477_-_\\uC724\\uACFD\\uC120",
    "data-name": "\\uC0AC\\uAC01\\uD615 154477 - \\uC724\\uACFD\\uC120",
    d: "M0-1H88.511a1,1,0,0,1,1,1V44.209a1,1,0,0,1-1,1H0a1,1,0,0,1-1-1V0A1,1,0,0,1,0-1ZM87.511,1H1V43.209H87.511Z",
    transform: "translate(574.445 379.215)",
    fill: "#414042"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uC0AC\\uAC01\\uD615_154478",
    "data-name": "\\uC0AC\\uAC01\\uD615 154478",
    d: "M2.911,0h48.8a2.911,2.911,0,0,1,2.911,2.911V6.982a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V2.911A2.911,2.911,0,0,1,2.911,0Z",
    transform: "translate(591.388 397.828)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uC0AC\\uAC01\\uD615_154478_-_\\uC724\\uACFD\\uC120",
    "data-name": "\\uC0AC\\uAC01\\uD615 154478 - \\uC724\\uACFD\\uC120",
    d: "M2.911-1h48.8a3.915,3.915,0,0,1,3.911,3.911V6.982a1,1,0,0,1-1,1H0a1,1,0,0,1-1-1V2.911A3.915,3.915,0,0,1,2.911-1ZM53.625,5.982V2.911A1.913,1.913,0,0,0,51.715,1H2.911A1.913,1.913,0,0,0,1,2.911V5.982Z",
    transform: "translate(591.388 397.828)",
    fill: "#414042"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_154479",
    "data-name": "\\uC0AC\\uAC01\\uD615 154479",
    width: 10.761,
    height: 238.494,
    transform: "translate(545.116 279.163)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uC0AC\\uAC01\\uD615_154479_-_\\uC724\\uACFD\\uC120",
    "data-name": "\\uC0AC\\uAC01\\uD615 154479 - \\uC724\\uACFD\\uC120",
    d: "M0-1H10.761a1,1,0,0,1,1,1V238.494a1,1,0,0,1-1,1H0a1,1,0,0,1-1-1V0A1,1,0,0,1,0-1ZM9.761,1H1V237.494H9.761Z",
    transform: "translate(545.116 279.163)",
    fill: "#414042"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_154480",
    "data-name": "\\uC0AC\\uAC01\\uD615 154480",
    width: 10.761,
    height: 238.494,
    transform: "translate(681.523 279.163)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uC0AC\\uAC01\\uD615_154480_-_\\uC724\\uACFD\\uC120",
    "data-name": "\\uC0AC\\uAC01\\uD615 154480 - \\uC724\\uACFD\\uC120",
    d: "M0-1H10.761a1,1,0,0,1,1,1V238.494a1,1,0,0,1-1,1H0a1,1,0,0,1-1-1V0A1,1,0,0,1,0-1ZM9.761,1H1V237.494H9.761Z",
    transform: "translate(681.523 279.163)",
    fill: "#414042"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_154481",
    "data-name": "\\uC0AC\\uAC01\\uD615 154481",
    width: 10.761,
    height: 238.494,
    transform: "translate(1243.929 279.163)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uC0AC\\uAC01\\uD615_154481_-_\\uC724\\uACFD\\uC120",
    "data-name": "\\uC0AC\\uAC01\\uD615 154481 - \\uC724\\uACFD\\uC120",
    d: "M0-1H10.761a1,1,0,0,1,1,1V238.494a1,1,0,0,1-1,1H0a1,1,0,0,1-1-1V0A1,1,0,0,1,0-1ZM9.761,1H1V237.494H9.761Z",
    transform: "translate(1243.929 279.163)",
    fill: "#414042"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_132689",
    "data-name": "\\uD328\\uC2A4 132689",
    d: "M775.247,238.449H729.415a1,1,0,0,1-.8-.4l-8.174-10.761a1,1,0,0,1,.291-1.468l16.982-9.948a1,1,0,0,1,.788-.1l8.873,2.615,9.709-4.822a1,1,0,0,1,1.445.9v11.657l17.235,10.469a1,1,0,0,1-.519,1.855Zm-45.336-2h41.763l-14.662-8.907a1,1,0,0,1-.481-.855V216.082l-8.615,4.279a1,1,0,0,1-.727.064l-8.834-2.6-15.636,9.159Z",
    transform: "translate(581.824 171.723)",
    fill: "#414042"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uC120_1643",
    "data-name": "\\uC120 1643",
    d: "M0,4.236a1,1,0,0,1-.907-.577A1,1,0,0,1-.423,2.329L6.5-.906a1,1,0,0,1,1.329.483A1,1,0,0,1,7.35.906L.423,4.141A1,1,0,0,1,0,4.236Z",
    transform: "translate(1322.37 391.188)",
    fill: "#414042"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uC120_1644",
    "data-name": "\\uC120 1644",
    d: "M0,5.134a1,1,0,0,1-1-1V0A1,1,0,0,1,0-1,1,1,0,0,1,1,0V4.134A1,1,0,0,1,0,5.134Z",
    transform: "translate(1339.356 398.41)",
    fill: "#414042"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_132690",
    "data-name": "\\uD328\\uC2A4 132690",
    d: "M761.5,226.425a1,1,0,0,1-.741-.328l-10.305-11.358-13.631,6.971a1,1,0,1,1-.911-1.781l14.313-7.32a1,1,0,0,1,1.2.218l10.819,11.925a1,1,0,0,1-.74,1.672Z",
    transform: "translate(602.986 170.368)",
    fill: "#414042"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_132691",
    "data-name": "\\uD328\\uC2A4 132691",
    d: "M759.7,238.45a1,1,0,0,1-.9-1.438l4.97-10.217-8.173-11.076-10.069,4.655a1,1,0,0,1-.839-1.815l10.809-5a1,1,0,0,1,1.224.314l9.016,12.219a1,1,0,0,1,.095,1.031L760.6,237.887A1,1,0,0,1,759.7,238.45Z",
    transform: "translate(615.205 171.723)",
    fill: "#414042"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_132692",
    "data-name": "\\uD328\\uC2A4 132692",
    d: "M776.363,235.536a1,1,0,0,1-.924-.616l-7.209-17.3-16.491,1.549a1,1,0,0,1-.187-1.991l17.224-1.618a1,1,0,0,1,1.017.611l7.492,17.984a1,1,0,0,1-.923,1.385Z",
    transform: "translate(624.354 174.636)",
    fill: "#414042"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_132693",
    "data-name": "\\uD328\\uC2A4 132693",
    d: "M791.239,312.963H732.177a1,1,0,0,1,0-2h58.186l10.276-77.224a1,1,0,0,1,1.983.264L792.23,312.095A1,1,0,0,1,791.239,312.963Z",
    transform: "translate(597.12 198.86)",
    fill: "#414042"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_154483",
    "data-name": "\\uC0AC\\uAC01\\uD615 154483",
    width: 111.685,
    height: 7.353,
    transform: "translate(1297.827 409.172)",
    fill: "#414042"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uC0AC\\uAC01\\uD615_154483_-_\\uC724\\uACFD\\uC120",
    "data-name": "\\uC0AC\\uAC01\\uD615 154483 - \\uC724\\uACFD\\uC120",
    d: "M0-1H111.685a1,1,0,0,1,1,1V7.353a1,1,0,0,1-1,1H0a1,1,0,0,1-1-1V0A1,1,0,0,1,0-1ZM110.685,1H1V6.353H110.685Z",
    transform: "translate(1297.827 409.172)",
    fill: "#414042"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "\\uD0C0\\uC6D0_21793",
    "data-name": "\\uD0C0\\uC6D0 21793",
    cx: 49.976,
    cy: 49.976,
    rx: 49.976,
    ry: 49.976,
    transform: "translate(1114.292)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD0C0\\uC6D0_21793_-_\\uC724\\uACFD\\uC120",
    "data-name": "\\uD0C0\\uC6D0 21793 - \\uC724\\uACFD\\uC120",
    d: "M49.976-1A50.989,50.989,0,0,1,69.818,96.945,50.989,50.989,0,0,1,30.133,3.006,50.657,50.657,0,0,1,49.976-1Zm0,99.951a48.989,48.989,0,0,0,19.063-94.1A48.989,48.989,0,0,0,30.912,95.1,48.668,48.668,0,0,0,49.976,98.951Z",
    transform: "translate(1114.292)",
    fill: "#414042"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "\\uD0C0\\uC6D0_21794",
    "data-name": "\\uD0C0\\uC6D0 21794",
    cx: 40.744,
    cy: 40.744,
    rx: 40.744,
    ry: 40.744,
    transform: "translate(1123.523 9.232)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD0C0\\uC6D0_21794_-_\\uC724\\uACFD\\uC120",
    "data-name": "\\uD0C0\\uC6D0 21794 - \\uC724\\uACFD\\uC120",
    d: "M40.744-1A41.755,41.755,0,0,1,56.993,79.207,41.755,41.755,0,0,1,24.5,2.281,41.484,41.484,0,0,1,40.744-1Zm0,81.488A39.755,39.755,0,0,0,56.214,4.123a39.755,39.755,0,0,0-30.94,73.242A39.494,39.494,0,0,0,40.744,80.488Z",
    transform: "translate(1123.523 9.232)",
    fill: "#414042"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uC120_1645",
    "data-name": "\\uC120 1645",
    d: "M0,27.854a1,1,0,0,1-1-1V0A1,1,0,0,1,0-1,1,1,0,0,1,1,0V26.854A1,1,0,0,1,0,27.854Z",
    transform: "translate(1164.268 23.122)",
    fill: "#414042"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uC120_1646",
    "data-name": "\\uC120 1646",
    d: "M9.494,10.494a1,1,0,0,1-.707-.293L-.707.707a1,1,0,0,1,0-1.414,1,1,0,0,1,1.414,0L10.2,8.787a1,1,0,0,1-.707,1.707Z",
    transform: "translate(1164.268 49.976)",
    fill: "#414042"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_185107",
    "data-name": "\\uADF8\\uB8F9 185107",
    transform: "translate(1127.282 12.986)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_132694",
    "data-name": "\\uD328\\uC2A4 132694",
    d: "M683.315,131.132a1.738,1.738,0,0,1,1.727-1.763h0a1.769,1.769,0,0,1,1.763,1.746h0a1.75,1.75,0,0,1-1.746,1.744h0A1.734,1.734,0,0,1,683.315,131.132ZM670.89,130.1a1.734,1.734,0,0,1-.943-2.269h0a1.726,1.726,0,0,1,2.267-.96h0a1.759,1.759,0,0,1,.962,2.286h0a1.766,1.766,0,0,1-1.624,1.082h0A1.9,1.9,0,0,1,670.89,130.1Zm26.036-1.029a1.718,1.718,0,0,1,.926-2.269h0a1.726,1.726,0,0,1,2.284.926h0a1.751,1.751,0,0,1-.943,2.286h0a1.466,1.466,0,0,1-.662.139h0A1.717,1.717,0,0,1,696.926,129.074Zm-38.042-6.947h0a1.738,1.738,0,0,1-.017-2.478h0a1.758,1.758,0,0,1,2.478,0h0a1.741,1.741,0,0,1,0,2.461h0a1.713,1.713,0,0,1-1.24.523h0A1.747,1.747,0,0,1,658.884,122.127Zm49.82-.156a1.742,1.742,0,0,1-.017-2.461h0a1.742,1.742,0,0,1,2.478-.017h0a1.758,1.758,0,0,1,0,2.478h0a1.786,1.786,0,0,1-1.238.506h0A1.756,1.756,0,0,1,708.7,121.971Zm-57.882-11.8a1.73,1.73,0,0,1,.924-2.286h0a1.73,1.73,0,0,1,2.286.924h0a1.75,1.75,0,0,1-.943,2.286h0a1.709,1.709,0,0,1-.662.142h0A1.742,1.742,0,0,1,650.822,110.174Zm66.052.732a1.749,1.749,0,0,1-.943-2.286h0a1.746,1.746,0,0,1,2.283-.943h0a1.748,1.748,0,0,1,.943,2.288h0a1.745,1.745,0,0,1-1.621,1.063h0A1.807,1.807,0,0,1,716.874,110.905ZM647.96,96.021v-.07h0v-.07h0a1.726,1.726,0,0,1,1.744-1.746h0a1.74,1.74,0,0,1,1.746,1.746h0v.07h0v.07h0a1.753,1.753,0,0,1-1.746,1.746h0A1.74,1.74,0,0,1,647.96,96.021Zm70.483-.209a1.738,1.738,0,0,1,1.744-1.746h0a1.726,1.726,0,0,1,1.746,1.727h0a1.74,1.74,0,0,1-1.746,1.746h0A1.724,1.724,0,0,1,718.443,95.812ZM651.709,84a1.726,1.726,0,0,1-.96-2.267h0a1.741,1.741,0,0,1,2.289-.943h0a1.735,1.735,0,0,1,.943,2.269h0a1.737,1.737,0,0,1-1.607,1.082h0A1.462,1.462,0,0,1,651.709,84ZM715.878,83a1.753,1.753,0,0,1,.943-2.286h0a1.757,1.757,0,0,1,2.284.943h0a1.728,1.728,0,0,1-.943,2.267h0a1.57,1.57,0,0,1-.679.142h0A1.744,1.744,0,0,1,715.878,83Zm-57.1-10.8a1.734,1.734,0,0,1,0-2.459h0a1.722,1.722,0,0,1,2.459-.019h0a1.753,1.753,0,0,1,0,2.478h0a1.738,1.738,0,0,1-1.238.506h0A1.736,1.736,0,0,1,658.778,72.2Zm49.822-.05a1.722,1.722,0,0,1,0-2.461h0a1.722,1.722,0,0,1,2.461,0h0a1.742,1.742,0,0,1,0,2.461h0a1.692,1.692,0,0,1-1.238.506h0A1.682,1.682,0,0,1,708.6,72.149Zm-38.793-8.168a1.752,1.752,0,0,1,.96-2.286h0a1.734,1.734,0,0,1,2.269.943h0a1.752,1.752,0,0,1-.943,2.286h0a1.751,1.751,0,0,1-.662.139h0A1.769,1.769,0,0,1,669.808,63.981Zm27.922.926h0a1.752,1.752,0,0,1-.943-2.286h0a1.73,1.73,0,0,1,2.269-.943h0a1.74,1.74,0,0,1,.96,2.267h0a1.758,1.758,0,0,1-1.624,1.084h0A1.725,1.725,0,0,1,697.729,64.907ZM683.157,60.63a1.751,1.751,0,0,1,1.746-1.744h0a1.749,1.749,0,0,1,1.744,1.744h0a1.738,1.738,0,0,1-1.744,1.746h0A1.751,1.751,0,0,1,683.157,60.63Z",
    transform: "translate(-647.96 -58.886)",
    fill: "#414042"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_132694_-_\\uC724\\uACFD\\uC120",
    "data-name": "\\uD328\\uC2A4 132694 - \\uC724\\uACFD\\uC120",
    d: "M685.059,133.859a2.739,2.739,0,0,1-2.744-2.717,2.7,2.7,0,0,1,.758-1.927,2.757,2.757,0,0,1,1.951-.846h.018a2.735,2.735,0,0,1,1.948.807,2.781,2.781,0,0,1,.815,1.92v.02A2.748,2.748,0,0,1,685.059,133.859Zm-.008-3.49a.769.769,0,0,0-.537.234.7.7,0,0,0-.2.509v.02a.737.737,0,0,0,.744.727.755.755,0,0,0,.746-.734A.767.767,0,0,0,685.051,130.369Zm-13.5.873a2.866,2.866,0,0,1-1.02-.205l-.024-.009a2.739,2.739,0,1,1,3.592-1.486l0,.006A2.757,2.757,0,0,1,671.552,131.242Zm-.292-2.068a.887.887,0,0,0,.292.068.771.771,0,0,0,.7-.466.735.735,0,0,0-.007-.566.759.759,0,0,0-.412-.411.724.724,0,0,0-.96.41l0,.006A.73.73,0,0,0,671.26,129.174Zm27.27,1.982a2.727,2.727,0,0,1-2.529-1.7,2.676,2.676,0,0,1-.021-2.072,2.744,2.744,0,0,1,5.081-.031,2.752,2.752,0,0,1-1.456,3.575A2.473,2.473,0,0,1,698.531,131.155Zm.009-3.494a.733.733,0,0,0-.292.061l-.015.006a.722.722,0,0,0-.4.4.692.692,0,0,0,.006.541l.018.043a.717.717,0,0,0,.672.441.5.5,0,0,0,.215-.033l.033-.016.034-.014a.73.73,0,0,0,.4-.4.752.752,0,0,0,0-.58A.721.721,0,0,0,698.539,127.662ZM660.1,123.633a2.746,2.746,0,0,1-1.924-.795,2.714,2.714,0,0,1-.824-1.919,2.752,2.752,0,0,1,.8-1.97l.006-.006a2.746,2.746,0,1,1,1.946,4.69Zm-.527-3.281a.765.765,0,0,0-.222.543.728.728,0,0,0,.225.515l.01.01a.742.742,0,0,0,.514.213.709.709,0,0,0,.518-.215l.014-.014a.746.746,0,0,0-1.058-1.052Zm50.349,3.125a2.757,2.757,0,0,1-1.928-.8l0,0a2.749,2.749,0,0,1-.021-3.869,2.714,2.714,0,0,1,1.953-.824,2.759,2.759,0,0,1,1.936.793l.007.007a2.758,2.758,0,0,1,0,3.893l-.018.017A2.79,2.79,0,0,1,709.927,123.477Zm-.517-2.214a.753.753,0,0,0,.517.214.786.786,0,0,0,.539-.222.758.758,0,0,0,0-1.05.769.769,0,0,0-.535-.221.729.729,0,0,0-.525.224l-.007.007A.745.745,0,0,0,709.41,121.263Zm-56.984-9.024a2.754,2.754,0,0,1-2.546-3.784,2.745,2.745,0,0,1,5.075-.025,2.743,2.743,0,0,1-.006,2.118,2.78,2.78,0,0,1-2.524,1.691Zm.007-3.494a.734.734,0,0,0-.292.061l-.015.006a.717.717,0,0,0-.393.4.731.731,0,0,0,.007.569l0,.009a.738.738,0,0,0,.683.452.718.718,0,0,0,.271-.062l.013-.005a.723.723,0,0,0,.395-.395.757.757,0,0,0,0-.584A.724.724,0,0,0,652.433,108.745Zm65.1,3.283a2.794,2.794,0,0,1-1.028-.192l-.012,0a2.709,2.709,0,0,1-1.483-1.474,2.746,2.746,0,0,1,2.529-3.813,2.788,2.788,0,0,1,1.047.2l.007,0a2.716,2.716,0,0,1,1.486,1.484,2.767,2.767,0,0,1,0,2.1l-.005.013A2.746,2.746,0,0,1,717.536,112.028Zm-.29-2.05a.808.808,0,0,0,.29.05.741.741,0,0,0,.3-1.425.8.8,0,0,0-.3-.058.738.738,0,0,0-.686.456.759.759,0,0,0,0,.585A.723.723,0,0,0,717.246,109.977ZM649.7,98.767a2.748,2.748,0,0,1-2.744-2.746v-.139a2.716,2.716,0,0,1,2.744-2.746,2.749,2.749,0,0,1,2.746,2.746v.139A2.749,2.749,0,0,1,649.7,98.767Zm0-3.632a.729.729,0,0,0-.744.746v.139a.737.737,0,0,0,.744.746.756.756,0,0,0,.746-.746v-.139A.738.738,0,0,0,649.7,95.136Zm70.452,3.4a2.737,2.737,0,0,1,.021-5.474h.039a2.737,2.737,0,0,1-.021,5.474Zm.03-3.474a.737.737,0,0,0-.744.746.721.721,0,0,0,.714.727h.03a.738.738,0,0,0,.746-.746.723.723,0,0,0-.716-.727Zm-67.813-9.928a2.441,2.441,0,0,1-1.074-.229,2.711,2.711,0,1,1,1.074.229Zm-.011-3.491a.754.754,0,0,0-.688.464.726.726,0,0,0,.408.958l.038.015.036.018a.508.508,0,0,0,.217.036.74.74,0,0,0,.683-.464.731.731,0,0,0-.4-.963l-.014-.006A.707.707,0,0,0,652.362,81.647Zm65.121,3.421a2.734,2.734,0,0,1-2.527-1.677l0-.006a2.747,2.747,0,0,1,5.069-2.121l.006.015a2.728,2.728,0,0,1-1.466,3.564A2.55,2.55,0,0,1,717.483,85.068Zm-.682-2.45a.748.748,0,0,0,.682.45.581.581,0,0,0,.255-.047l.046-.02a.723.723,0,0,0,.4-.392.736.736,0,0,0,0-.561.768.768,0,0,0-.7-.464.736.736,0,0,0-.283.057A.75.75,0,0,0,716.8,82.618ZM660,73.705a2.745,2.745,0,0,1,.019-5.491,2.748,2.748,0,0,1,1.927,4.691A2.75,2.75,0,0,1,660,73.705Zm.019-3.491a.729.729,0,0,0-.524.224l-.01.01a.734.734,0,0,0,0,1.042l0,0a.746.746,0,0,0,1.037,0l.008-.008a.753.753,0,0,0,0-1.06A.722.722,0,0,0,660.018,70.214Zm49.806,3.44a2.693,2.693,0,0,1-1.939-.808,2.734,2.734,0,0,1-.8-1.953,2.69,2.69,0,0,1,.814-1.917,2.735,2.735,0,0,1,1.942-.806,2.688,2.688,0,0,1,1.935.815,2.749,2.749,0,0,1,0,3.862A2.683,2.683,0,0,1,709.824,73.655Zm.015-3.484a.749.749,0,0,0-.531.224l-.009.009a.7.7,0,0,0-.216.5.748.748,0,0,0,.224.536l.017.018a.752.752,0,0,0,1.015,0l.013-.014a.745.745,0,0,0,0-1.05l-.007-.007A.7.7,0,0,0,709.839,70.17Zm-38.407-4.108a2.776,2.776,0,0,1-2.542-1.684l-.007-.016a2.719,2.719,0,0,1,0-2.1,2.774,2.774,0,0,1,1.49-1.488l.009,0a2.745,2.745,0,0,1,2.089,5.078A2.761,2.761,0,0,1,671.432,66.063Zm-.7-2.471a.733.733,0,0,0,.983.408.75.75,0,0,0,.4-.981.733.733,0,0,0-.679-.457.742.742,0,0,0-.28.056A.755.755,0,0,0,670.729,63.592Zm27.662,2.437a2.742,2.742,0,0,1,0-5.484,2.766,2.766,0,0,1,2.54,1.68,2.7,2.7,0,0,1,.013,2.1A2.745,2.745,0,0,1,698.391,66.029Zm0-3.484a.727.727,0,0,0-.675.454.756.756,0,0,0,0,.581.7.7,0,0,0,.68.449.763.763,0,0,0,.7-.465.712.712,0,0,0,0-.556.766.766,0,0,0-.7-.463Zm-13.484.831a2.745,2.745,0,1,1,2.744-2.746A2.749,2.749,0,0,1,684.9,63.376Zm0-3.49a.755.755,0,0,0-.746.744.747.747,0,0,0,.746.746.737.737,0,0,0,.744-.746A.745.745,0,0,0,684.9,59.886Z",
    transform: "translate(-647.96 -58.886)",
    fill: "#707070"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_185108",
    "data-name": "\\uADF8\\uB8F9 185108",
    transform: "translate(849.043 89.577)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uC120_1647",
    "data-name": "\\uC120 1647",
    d: "M16.869,17.869a1,1,0,0,1-.707-.293L-.707.707a1,1,0,0,1,0-1.414,1,1,0,0,1,1.414,0L17.576,16.162a1,1,0,0,1-.707,1.707Z",
    transform: "translate(0 13.623)",
    fill: "#414042"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uC120_1648",
    "data-name": "\\uC120 1648",
    d: "M16.869,17.869a1,1,0,0,1-.707-.293L-.707.707a1,1,0,0,1,0-1.414,1,1,0,0,1,1.414,0L17.576,16.162a1,1,0,0,1-.707,1.707Z",
    transform: "translate(44.196 13.623)",
    fill: "#414042"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uC120_1649",
    "data-name": "\\uC120 1649",
    d: "M33.106,34.106a1,1,0,0,1-.707-.293L-.707.707a1,1,0,0,1,0-1.414,1,1,0,0,1,1.414,0L33.813,32.4a1,1,0,0,1-.707,1.707Z",
    transform: "translate(58.176 5.505)",
    fill: "#414042"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uC120_1650",
    "data-name": "\\uC120 1650",
    d: "M14.491,15.491a1,1,0,0,1-.707-.293L-.707.707a1,1,0,0,1,0-1.414,1,1,0,0,1,1.414,0L15.2,13.784a1,1,0,0,1-.707,1.707Z",
    transform: "translate(89.581 14.812)",
    fill: "#414042"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uC120_1651",
    "data-name": "\\uC120 1651",
    d: "M44.116,45.116a1,1,0,0,1-.707-.293L-.707.707a1,1,0,0,1,0-1.414,1,1,0,0,1,1.414,0L44.823,43.409a1,1,0,0,1-.707,1.707Z",
    transform: "translate(8.475)",
    fill: "#414042"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_185110",
    "data-name": "\\uADF8\\uB8F9 185110",
    transform: "translate(1139.167 215.613)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_132695",
    "data-name": "\\uD328\\uC2A4 132695",
    d: "M694.729,146.043l-4.051,46.622H659.429l-4.4-46.622Z",
    transform: "translate(-649.953 -139.602)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_132695_-_\\uC724\\uACFD\\uC120",
    "data-name": "\\uD328\\uC2A4 132695 - \\uC724\\uACFD\\uC120",
    d: "M655.032,145.043h39.7a1,1,0,0,1,1,1.087l-4.051,46.622a1,1,0,0,1-1,.913H659.429a1,1,0,0,1-1-.906l-4.4-46.622a1,1,0,0,1,1-1.094Zm38.607,2H656.13l4.209,44.622h29.422Z",
    transform: "translate(-649.953 -139.602)",
    fill: "#414042"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_185109",
    "data-name": "\\uADF8\\uB8F9 185109",
    transform: "translate(18.311 6.441)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uC120_1652",
    "data-name": "\\uC120 1652",
    d: "M1.324,47.622a1,1,0,0,1-1-.972L-1,.028A1,1,0,0,1-.028-1,1,1,0,0,1,1-.028L2.325,46.594a1,1,0,0,1-.971,1.028Z",
    fill: "#414042"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uC120_1653",
    "data-name": "\\uC120 1653",
    d: "M0,47.622H-.028A1,1,0,0,1-1,46.594L.325-.028A1,1,0,0,1,1.353-1,1,1,0,0,1,2.325.028L1,46.651A1,1,0,0,1,0,47.622Z",
    transform: "translate(11.908)",
    fill: "#414042"
  })), /*#__PURE__*/React.createElement("path", {
    id: "\\uC120_1654",
    "data-name": "\\uC120 1654",
    d: "M35.844,1H0A1,1,0,0,1-1,0,1,1,0,0,1,0-1H35.844a1,1,0,0,1,1,1A1,1,0,0,1,35.844,1Z",
    transform: "translate(7.179 14.695)",
    fill: "#414042"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uC120_1655",
    "data-name": "\\uC120 1655",
    d: "M35.844,1H0A1,1,0,0,1-1,0,1,1,0,0,1,0-1H35.844a1,1,0,0,1,1,1A1,1,0,0,1,35.844,1Z",
    transform: "translate(7.179 24.287)",
    fill: "#414042"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uC120_1656",
    "data-name": "\\uC120 1656",
    d: "M33.843,1H0A1,1,0,0,1-1,0,1,1,0,0,1,0-1H33.843a1,1,0,0,1,1,1A1,1,0,0,1,33.843,1Z",
    transform: "translate(8.179 33.879)",
    fill: "#414042"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uC120_1657",
    "data-name": "\\uC120 1657",
    d: "M32.034,1H0A1,1,0,0,1-1,0,1,1,0,0,1,0-1H32.034a1,1,0,0,1,1,1A1,1,0,0,1,32.034,1Z",
    transform: "translate(9.084 43.471)",
    fill: "#414042"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_154484",
    "data-name": "\\uC0AC\\uAC01\\uD615 154484",
    width: 49.855,
    height: 6.441,
    rx: 1.343,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uC0AC\\uAC01\\uD615_154484_-_\\uC724\\uACFD\\uC120",
    "data-name": "\\uC0AC\\uAC01\\uD615 154484 - \\uC724\\uACFD\\uC120",
    d: "M1.343-1h47.17a2.345,2.345,0,0,1,2.343,2.343V5.1a2.345,2.345,0,0,1-2.343,2.343H1.343A2.345,2.345,0,0,1-1,5.1V1.343A2.345,2.345,0,0,1,1.343-1Zm47.17,6.441a.343.343,0,0,0,.343-.343V1.343A.343.343,0,0,0,48.512,1H1.343A.343.343,0,0,0,1,1.343V5.1a.343.343,0,0,0,.343.343Z",
    fill: "#414042"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_154485",
    "data-name": "\\uC0AC\\uAC01\\uD615 154485",
    width: 117.502,
    height: 65.424,
    transform: "translate(591.388 203.252)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uC0AC\\uAC01\\uD615_154485_-_\\uC724\\uACFD\\uC120",
    "data-name": "\\uC0AC\\uAC01\\uD615 154485 - \\uC724\\uACFD\\uC120",
    d: "M0-1H117.5a1,1,0,0,1,1,1V65.424a1,1,0,0,1-1,1H0a1,1,0,0,1-1-1V0A1,1,0,0,1,0-1ZM116.5,1H1V64.424H116.5Z",
    transform: "translate(591.388 203.252)",
    fill: "#414042"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_185111",
    "data-name": "\\uADF8\\uB8F9 185111",
    transform: "translate(599.386 198.308)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_154486",
    "data-name": "\\uC0AC\\uAC01\\uD615 154486",
    width: 9.307,
    height: 14.833,
    rx: 1.94,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uC0AC\\uAC01\\uD615_154486_-_\\uC724\\uACFD\\uC120",
    "data-name": "\\uC0AC\\uAC01\\uD615 154486 - \\uC724\\uACFD\\uC120",
    d: "M1.94-1H7.367a2.943,2.943,0,0,1,2.94,2.94V12.893a2.943,2.943,0,0,1-2.94,2.94H1.94A2.943,2.943,0,0,1-1,12.893V1.94A2.943,2.943,0,0,1,1.94-1ZM7.367,13.833a.941.941,0,0,0,.94-.94V1.94A.941.941,0,0,0,7.367,1H1.94A.941.941,0,0,0,1,1.94V12.893a.941.941,0,0,0,.94.94Z",
    fill: "#414042"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_154487",
    "data-name": "\\uC0AC\\uAC01\\uD615 154487",
    width: 9.307,
    height: 14.833,
    rx: 1.94,
    transform: "translate(18.44)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uC0AC\\uAC01\\uD615_154487_-_\\uC724\\uACFD\\uC120",
    "data-name": "\\uC0AC\\uAC01\\uD615 154487 - \\uC724\\uACFD\\uC120",
    d: "M1.94-1H7.367a2.943,2.943,0,0,1,2.94,2.94V12.893a2.943,2.943,0,0,1-2.94,2.94H1.94A2.943,2.943,0,0,1-1,12.893V1.94A2.943,2.943,0,0,1,1.94-1ZM7.367,13.833a.941.941,0,0,0,.94-.94V1.94A.941.941,0,0,0,7.367,1H1.94A.941.941,0,0,0,1,1.94V12.893a.941.941,0,0,0,.94.94Z",
    transform: "translate(18.44)",
    fill: "#414042"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_154488",
    "data-name": "\\uC0AC\\uAC01\\uD615 154488",
    width: 9.307,
    height: 14.833,
    rx: 1.94,
    transform: "translate(36.879)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uC0AC\\uAC01\\uD615_154488_-_\\uC724\\uACFD\\uC120",
    "data-name": "\\uC0AC\\uAC01\\uD615 154488 - \\uC724\\uACFD\\uC120",
    d: "M1.94-1H7.367a2.943,2.943,0,0,1,2.94,2.94V12.893a2.943,2.943,0,0,1-2.94,2.94H1.94A2.943,2.943,0,0,1-1,12.893V1.94A2.943,2.943,0,0,1,1.94-1ZM7.367,13.833a.941.941,0,0,0,.94-.94V1.94A.941.941,0,0,0,7.367,1H1.94A.941.941,0,0,0,1,1.94V12.893a.941.941,0,0,0,.94.94Z",
    transform: "translate(36.879)",
    fill: "#414042"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_154489",
    "data-name": "\\uC0AC\\uAC01\\uD615 154489",
    width: 9.307,
    height: 14.833,
    rx: 1.94,
    transform: "translate(55.319)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uC0AC\\uAC01\\uD615_154489_-_\\uC724\\uACFD\\uC120",
    "data-name": "\\uC0AC\\uAC01\\uD615 154489 - \\uC724\\uACFD\\uC120",
    d: "M1.94-1H7.367a2.943,2.943,0,0,1,2.94,2.94V12.893a2.943,2.943,0,0,1-2.94,2.94H1.94A2.943,2.943,0,0,1-1,12.893V1.94A2.943,2.943,0,0,1,1.94-1ZM7.367,13.833a.941.941,0,0,0,.94-.94V1.94A.941.941,0,0,0,7.367,1H1.94A.941.941,0,0,0,1,1.94V12.893a.941.941,0,0,0,.94.94Z",
    transform: "translate(55.319)",
    fill: "#414042"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_154490",
    "data-name": "\\uC0AC\\uAC01\\uD615 154490",
    width: 9.307,
    height: 14.833,
    rx: 1.94,
    transform: "translate(73.759)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uC0AC\\uAC01\\uD615_154490_-_\\uC724\\uACFD\\uC120",
    "data-name": "\\uC0AC\\uAC01\\uD615 154490 - \\uC724\\uACFD\\uC120",
    d: "M1.94-1H7.367a2.943,2.943,0,0,1,2.94,2.94V12.893a2.943,2.943,0,0,1-2.94,2.94H1.94A2.943,2.943,0,0,1-1,12.893V1.94A2.943,2.943,0,0,1,1.94-1ZM7.367,13.833a.941.941,0,0,0,.94-.94V1.94A.941.941,0,0,0,7.367,1H1.94A.941.941,0,0,0,1,1.94V12.893a.941.941,0,0,0,.94.94Z",
    transform: "translate(73.759)",
    fill: "#414042"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_154491",
    "data-name": "\\uC0AC\\uAC01\\uD615 154491",
    width: 9.307,
    height: 14.833,
    rx: 1.94,
    transform: "translate(92.198)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uC0AC\\uAC01\\uD615_154491_-_\\uC724\\uACFD\\uC120",
    "data-name": "\\uC0AC\\uAC01\\uD615 154491 - \\uC724\\uACFD\\uC120",
    d: "M1.94-1H7.367a2.943,2.943,0,0,1,2.94,2.94V12.893a2.943,2.943,0,0,1-2.94,2.94H1.94A2.943,2.943,0,0,1-1,12.893V1.94A2.943,2.943,0,0,1,1.94-1ZM7.367,13.833a.941.941,0,0,0,.94-.94V1.94A.941.941,0,0,0,7.367,1H1.94A.941.941,0,0,0,1,1.94V12.893a.941.941,0,0,0,.94.94Z",
    transform: "translate(92.198)",
    fill: "#414042"
  })), /*#__PURE__*/React.createElement("path", {
    id: "\\uC120_1659",
    "data-name": "\\uC120 1659",
    d: "M1099.112,1H0A1,1,0,0,1-1,0,1,1,0,0,1,0-1H1099.112a1,1,0,0,1,1,1A1,1,0,0,1,1099.112,1Z",
    transform: "translate(329.978 517.657)",
    fill: "#414042"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_139426",
    "data-name": "\\uD328\\uC2A4 139426",
    d: "M286.978,1H0A1,1,0,0,1-1,0,1,1,0,0,1,0-1H286.978a1,1,0,0,1,1,1A1,1,0,0,1,286.978,1Z",
    transform: "translate(1205.011 239.9)",
    fill: "#414042"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uC120_1666",
    "data-name": "\\uC120 1666",
    d: "M245.889.749H0A.749.749,0,0,1-.749,0,.749.749,0,0,1,0-.749H245.889a.749.749,0,0,1,.749.749A.749.749,0,0,1,245.889.749Z",
    transform: "translate(-173.222 517.657)",
    fill: "#414042"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uC120_1667",
    "data-name": "\\uC120 1667",
    d: "M75.283,1H0A1,1,0,0,1-1,0,1,1,0,0,1,0-1H75.283a1,1,0,0,1,1,1A1,1,0,0,1,75.283,1Z",
    transform: "translate(210.392 517.657)",
    fill: "#414042"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_132696",
    "data-name": "\\uD328\\uC2A4 132696",
    d: "M698.318,260.755H680.364a1,1,0,0,1,0-2h16.954v-18.23a1,1,0,0,1,2,0v19.23A1,1,0,0,1,698.318,260.755Z",
    transform: "translate(524.647 208.169)",
    fill: "#414042"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uC120_1670",
    "data-name": "\\uC120 1670",
    d: "M0,38.227a1,1,0,0,1-1-1V0A1,1,0,0,1,0-1,1,1,0,0,1,1,0V37.227A1,1,0,0,1,0,38.227Z",
    transform: "translate(1222.965 279.163)",
    fill: "#414042"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uC120_1671",
    "data-name": "\\uC120 1671",
    d: "M0,53.437a1,1,0,0,1-1-1V0A1,1,0,0,1,0-1,1,1,0,0,1,1,0V52.437A1,1,0,0,1,0,53.437Z",
    transform: "translate(713.646 341.986)",
    fill: "#414042"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_185112",
    "data-name": "\\uADF8\\uB8F9 185112",
    transform: "translate(628.597 218.49)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "AUG",
    transform: "translate(21 17)",
    fill: "#414042",
    fontSize: 18,
    fontFamily: "Montserrat-Black, Montserrat",
    fontWeight: 800
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -21.096,
    y: 0
  }, "AUG")), /*#__PURE__*/React.createElement("text", {
    id: "_17",
    "data-name": 17,
    transform: "translate(19.949 33.517)",
    fill: "#414042",
    fontSize: 17,
    fontFamily: "Montserrat-Regular, Montserrat"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -8.075,
    y: 0
  }, "17"))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEngineering1);
export default __webpack_public_path__ + "static/media/Engineering_1.c9c5504b4a4f276628915d8c47e0f90b.svg";
export { ForwardRef as ReactComponent };